<template>
	<div>
		<money
			v-model="data" :id="question.id" :name="question.id"
			:fractions="true"
			@blur="update()"/>
	</div>
</template>
<script>
import questions from "../../../../../mixins/questions";

export default {
	mixins: [
		questions,
	],

	data() {
		return {
			timeout: null,
		};
	},

	methods: {
		update() {
			clearTimeout(this.timeout);
			this.timeout = null;
			this.updateForm(this.question, this.setKey, this.data, this.initialized);
		},
	},

	watch: {
		"data": {
			immediate: false,
			handler: function () {
				if (!this.initialized) {
					return;
				}
				clearTimeout(this.timeout);
				this.timeout = null;
				this.timeout = setTimeout(() => {
					this.update();
				}, 3000);
			}
		},
	},
};
</script>
